/* eslint-disable eqeqeq */

import { useState } from "react";
import { useForm } from "@mantine/form";

import {
  Alert,
  Checkbox,
  Group,
  Modal,
  Select,
  Space,
  Text,
} from "@mantine/core";

import { Button } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

import { collectionGroup, getDocs, getFirestore, query, where, updateDoc, Timestamp } from "firebase/firestore";
import { BaseResult, NotificationMSG, Order } from "../types";
import { httpsCallable } from "firebase/functions";
import { useFunctions } from "../helpers/firebaseContext";





type FormProps = {
  fund: string;
  rmsOnly?: boolean;
};


const PaymentReminderModal = (props: any) => {

  const opened: boolean = props.opened;
  const setOpened = props.setOpened;
  const [confirming, setConfirming] = useState<boolean>(false);
  const [msg, setMsg] = useState<NotificationMSG | null>(null);

  const db = getFirestore();
  const functions = useFunctions();
  functions.region = "europe-west1";
  const sendPaymentReminder = httpsCallable<{
    orders: string[],
    rmsOnly?: boolean
  }, BaseResult>(functions, "sendPaymentReminder");



  const handleSubmit = async (data: FormProps) => {
    if (data?.fund) {

      let ordersQuery = query(collectionGroup(db, "orders"),
        where("fund.id", "==", data.fund),
        where("tags.orderStatus.code", "==", "need_slip"),
      )

      const ordersSnapshot = await getDocs(ordersQuery);
      if (!ordersSnapshot.docs.length) {
        return setMsg({ type: "error", message: "no orders waiting for payment found" });
      }

      setMsg({ type: "success", message: `found ${ordersSnapshot.docs.length} orders with status 'need slip', updating` });


      let ordersArray = [];
      for (const orderDoc of ordersSnapshot.docs) {
        ordersArray.push(orderDoc.id);
      }
      try {
        const result = await sendPaymentReminder({
          orders: ordersArray,
          rmsOnly: data.rmsOnly || false
        });
        console.log("result from cloud function:", result);

      } catch (error) {
        console.log("error sending payment reminders:", error);
        setMsg({ type: "error", message: "Error sending payment reminders. Check console for details." });
        return;
      }


    } else {
      setMsg({ type: "error", message: "Fund not selected" });
    }

  }
  const form = useForm<FormProps>({

  });

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {
          setMsg(null);
          setOpened(false);
          setConfirming(false)
        }}
        title="Collect Payment for fund"
      >

        <Text>
          This sends an SMS message to all clients with orders with the status "Need Slip", requesting the client to pay for their order if not already paid
        </Text>

        <Space h="xl" />

        <form
          onSubmit={form.onSubmit(async (values) => {
            console.log(values);



            // setConfirmDialogError(null);
            setMsg(null);
            // props?.setPending(true)

            setConfirming(true);


            try {

              await handleSubmit(values)

              // setIsError(true);
              // setMsg({ type: "success", message: "Updating orders statuses to " });
            } catch (error: any) {
              // setIsError(true);
              console.log(error);
              // setMsg(error.message);
              // setMsg({type:"error",msg:});
              setMsg({ type: "error", message: error.message });


              // setConfirmDialogError(error.message);
            }

            setConfirming(false);

          })}
        >





          <Select
            {...form.getInputProps("fund")}
            label="Select fund"
            placeholder="choose fund"
            //Todo: need to hcnage this to use firestore funds that are active with collection date set with a valid value 
            data={[
              { value: '3007', label: 'UK Real Estate Fund VI LP' },
              { value: '50001', label: 'Trade Finance' },
            ]}
          />
          <Space h="xl" />
          <Checkbox
            label={"Notify only the RMs"}
            {...form.getInputProps("rmsOnly", { type: "checkbox" })}
            checked={form.values.rmsOnly || false}
          />


          <Space h="xl" />
          <Group>
            <Button color="grape" type="submit" loading={confirming}>
              Send Payment Notification
            </Button>
          </Group>

          <Space h="xl" />

          {msg && (
            <Alert
              icon={<IconAlertCircle size={16} />}
              color={msg.type == "success" ? "green" : msg.type == "info" ? "blue" : "red"}
              title={msg.type == "success" ? "Success" : msg.type == "info" ? "Info" : "Failure"}
            >


              {msg.message}
              <br />


            </Alert>
          )}

        </form>
      </Modal >
    </>
  );
}

export default PaymentReminderModal;